import moment from 'moment';

export * from './rewarding';
export * from './training';

export enum BulkApprovalAction {
  APPROVE = 'approve',
  REJECT = 'reject',
}

export enum BulkApprovalStatus {
  FAILED = 'failed',
  SUCCESS = 'success',
}

export const getFormattedDate = (date: string | Date, format = 'DD.MM.YYYY') =>
  moment(date).format(format);

export enum BulkApprovalCategory {
  SALARY = 'SALARY',
  SALARY_PROPOSAL = 'SALARY_PROPOSAL',
  ALLOWANCE = 'ALLOWANCE',
  ALLOWANCE_PROPOSAL = 'ALLOWANCE_PROPOSAL',
  BENEFIT = 'BENEFIT',
  BENEFIT_PROPOSAL = 'BENEFIT_PROPOSAL',
  INCENTIVE_SHORT = 'INCENTIVE_SHORT',
  INCENTIVE_SHORT_PROPOSAL = 'INCENTIVE_SHORT_PROPOSAL',
  INCENTIVE_SHORT_PAID = 'INCENTIVE_SHORT_PAID',
  INCENTIVE_LONG = 'INCENTIVE_LONG',
  INCENTIVE_LONG_PAID = 'INCENTIVE_LONG_PAID',
  BILLABLE_HOURS = 'BILLABLE_HOURS',
  BILLABLE_HOURS_PROPOSAL = 'BILLABLE_HOURS_PROPOSAL',
  BILLABLE_HOURS_PAID = 'BILLABLE_HOURS_PAID',
}

export enum ApprovalWidgetCategory {
  Absences = 'absences',
  Allowance = 'allowance',
  Benefit = 'benefit',
  Incentive = 'incentive',
  Salary = 'salary',
  Training = 'training',
}
